import { useState, FunctionComponent, Suspense } from "react";
import { Container, containerContext } from "../injection";
import { BridgeThemeProvider } from "./BridgeThemeProvider";
import { windowAsAny } from "../windowAsAny/windowAsAny";
import { createRoot } from "react-dom/client";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GenericType = any;

interface IBridge {
    updateProps: (props: GenericType) => void;
    destroy: () => void;
}

export function createBridge(
    name: string,
    Component: FunctionComponent<GenericType>,
    injectionContainer: Container
) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const w = windowAsAny();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    w._reactBridges ??= {};

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    w._reactBridges[name] = (
        container: HTMLElement,
        props: GenericType,
        theme?: string
    ): IBridge => {
        let propsSetter: (props: GenericType) => void = () => {
            /* do nothing, will be replaced */
        };

        // eslint-disable-next-line react-compiler/react-compiler
        const Bridge = () => {
            "use no memo";

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const [myProps, setMyProps] = useState(props);
            // eslint-disable-next-line react-compiler/react-compiler
            propsSetter = setMyProps;

            return (
                <containerContext.Provider value={injectionContainer}>
                    <BridgeThemeProvider theme={theme}>
                        {/* suspense here to avoid errors. ideally suspense will be caught before this. */}
                        <Suspense fallback={null}>
                            <Component {...myProps} />
                        </Suspense>
                    </BridgeThemeProvider>
                </containerContext.Provider>
            );
        };

        const root = createRoot(container);
        root.render(<Bridge />);

        return {
            updateProps: (newProps: GenericType) => {
                propsSetter(newProps);
            },
            destroy: () => {
                root.unmount();
            }
        };
    };
}
